export class QuestionBankModel {
    id: number;
    qno: number;
    marks: number;
    question: string;
    className: string;
    subject: string;
    chapter: string;
    language: string;
    isActive: number;
  
    constructor(
      id: number,
      qno: number,
      marks: number,
      question: string,
      className: string,
      subject: string,
      chapter: string,
      language: string,
      isActive: number
    ) {
      this.id = id;
      this.qno = qno;
      this.marks = marks;
      this.question = question;
      this.className = className;
      this.subject = subject;
      this.chapter = chapter;
      this.language = language;
      this.isActive = isActive;
    }
  }
  